import MoveableDiv from './MoveableDiv.jsx';

export default MoveableDiv;



// WEBPACK FOOTER //
// ./src/components/Header/MoveableDiv/index.js